import "./IntegrationTile.scss";
import Message from "../../../i18n/Message";
import label from "../../../i18n/label";
import { useIntl } from "react-intl";
import { useState } from "react";
import TrashIcon from "../../../assets/icons/TrashIcon";
import Spinner from "../../../assets/icons/Spinner";
import CheckIcon from "../../../assets/icons/CheckIcon";
import XIcon from "../../../assets/icons/CrossIcon";
import backend from "../../../backend/backend";
import Notify from "../../shared/Notify";
import { useParams } from "react-router-dom";
import LogoConfluence from "../../../assets/icons/LogoConfluence";

const getIntegrationLogo = (type) => {
  switch (type) {
    case "CONFLUENCE":
      return <LogoConfluence size={36} />;
    default:
      return type?.charAt(0) || "?";
  }
};

const getIntegrationTitle = (type) => {
  switch (type) {
    case "CONFLUENCE":
      return "Confluence";
    case "GOOGLE_DRIVE":
      return "Google Drive";
    case "GOOGLE_DOCS":
      return "Google Docs";
    case "NOTION":
      return "Notion";
    case "SHAREPOINT":
      return "SharePoint";
    default:
      return type;
  }
};

const IntegrationTile = ({ integration, onDelete }) => {
  const intl = useIntl();
  const { workspaceId } = useParams();
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDeleteConfirmed = () => {
    setIsDeleting(true);

    backend
      .deleteIntegration(workspaceId, integration.uid)
      .then(() => {
        Notify.success(label(intl, "integration_deleted"));
        setIsDeleting(false);
        setShowDeleteConfirm(false);
        if (onDelete) {
          onDelete(integration.uid);
        }
      })
      .catch((err) => {
        console.error("Failed to delete integration", err);
        Notify.error(label(intl, "error_delete_integration"));
        setIsDeleting(false);
        setShowDeleteConfirm(false);
      });
  };

  // Extract username from name (format: "Confluence - username@domain.com")
  const username = integration.name?.split(" - ")[1] || integration.name;

  return (
    <div className="integration_tile d-flex">
      <div className="integration_logo">
        {getIntegrationLogo(integration.type)}
      </div>
      <div className="content_rows">
        <div className="integration_header">
          <div className="integration_title">
            {getIntegrationTitle(integration.type)}
          </div>
          {integration.lastTestStatus && (
            <div
              className={`test_status ${integration.lastTestStatus.toLowerCase()}`}
            >
              {integration.lastTestStatus === "SUCCESS" ? (
                <>
                  <CheckIcon size={14} color="#28a745" />
                  <span>
                    <Message id="integration_test_success" />
                  </span>
                </>
              ) : (
                <>
                  <XIcon size={14} color="#dc3545" />
                  <span>
                    <Message id="integration_test_failed" />
                  </span>
                </>
              )}
            </div>
          )}
        </div>
        <div className="integration_details">
          <div className="detail_row">
            <span className="label">Username:</span>
            <span className="value">{username}</span>
          </div>
          {integration.baseUrl && (
            <div className="detail_row">
              <span className="label">URL:</span>
              <span className="value">{integration.baseUrl}</span>
            </div>
          )}
        </div>
        <div className="integration_actions">
          <div className="confirm_container">
            {showDeleteConfirm && (
              <>
                <div
                  className="cover"
                  onClick={() => setShowDeleteConfirm(false)}
                ></div>
                <div className="confirm_panel">
                  <button
                    className="btn bg-gradient-primary btn-sm"
                    onClick={handleDeleteConfirmed}
                    disabled={isDeleting}
                  >
                    {isDeleting ? (
                      <Spinner size={16} color="#fff" />
                    ) : (
                      <Message id="confirm_delete" />
                    )}
                  </button>
                </div>
              </>
            )}
          </div>
          <button
            className="btn btn-outline-danger btn-sm"
            type="button"
            onClick={() => setShowDeleteConfirm(true)}
            disabled={isDeleting}
          >
            <TrashIcon size={16} color="#dc3545" />
            <Message id="delete" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntegrationTile;
